<template>
  <div>
    <loader v-if="pageLoader"></loader>
    <div v-if="top_sectionArr[current_top_index]">
      <slideShow
        v-if="showSlideShow"
        :toggleSlideShow="closeSlideShow"
        :imageArray="top_sectionArr"
        @like="changeCnt"
      />
      <!-- toolbar -->
      <div
        class="search-top-city-container"
        id="sticky-search-bar"
        v-if="!fullScreen"
      >
        <div class="toolbar-content-container">
          <div style="flex-grow: 1">
            <a
              href="https://www.withaview.co"
              class="go-back-icon-and-fullscreen-mobile"
            >
              <label>{{ filterViewType }}</label>
              <div class="logo">
                <img
                  src="/static/img/icons/wav-logo.png"
                  alt="logo"
                  height="30px"
                />
              </div>
            </a>
          </div>
          <div class="list-view-text" style="cursor: pointer">
            <a href="https://www.withaview.co" class="text-decoration-none">
              <img
                src="/static/img/icons/wav-logo.png"
                class="hidden-md-and-up mt-2"
                height="24px"
            /></a>
            <span class="search-component">
              <searchContainer />
            </span>
          </div>
          <div class="header-section-3">
            <div
              style="display: flex; flex-direction: column"
              @click="
                isLoggedIn
                  ? $router.push({
                      path: '/profile',
                      query: {
                        profile_Id: user.uid,
                        selected_tab: 'checkins',
                      },
                    })
                  : $router.push(`/login`)
              "
            >
              <div class="pill-container">
                <div class="pill pointer" style="color: #b6b6b6; flex-grow: 1">
                  <i class="material-icons">note_add</i>
                </div>
                <div style="border: 0.5px solid #b6b6b6; width: 1px"></div>
                <div class="pill pointer">
                  <i
                    class="material-icons"
                    v-if="!isLoggedIn && this.screenW < 600"
                    >account_circle</i
                  >
                  <i
                    class="material-icons"
                    v-if="!isLoggedIn && this.screenW > 600"
                    >perm_identity</i
                  >
                  <img
                    :src="this.$store.state.auth.user.photoURL"
                    v-if="isLoggedIn"
                    style="height: 1.75rem; width: 1.75rem; border-radius: 100%"
                  />
                </div>
              </div>
              <div class="pills-description">
                <label
                  class="description-item pointer"
                  @click="
                    isLoggedIn
                      ? $router.push({
                          path: '/profile',
                          query: {
                            profile_Id: user.uid,
                            selected_tab: 'checkins',
                          },
                        })
                      : $router.push(`/login`)
                  "
                  >Travel list</label
                >
                <label
                  class="description-item pointer"
                  @click="
                    isLoggedIn
                      ? $router.push({
                          path: '/profile',
                          query: {
                            profile_Id: user.uid,
                            selected_tab: 'checkins',
                          },
                        })
                      : $router.push(`/login`)
                  "
                  >Profile</label
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- toolbar ends -->
      <div class="disable-select" v-if="Object.keys(imageInfo).length !== 0">
        <div>
          <div
            class="image-details-container"
            @scroll="getScrollPos"
            id="image-details-container"
          >
            <!-- NEW -->
            <div class="media-top-section">
              <div class="top-section">
                <span class="photo-details photo-details-description">
                  <span class="caption">
                    {{
                      this.top_sectionArr[current_top_index].caption
                        ? this.top_sectionArr[current_top_index].caption
                        : ""
                    }}
                  </span>
                  <span class="location">
                    <pre
                      :class="
                        getSpotType(top_sectionArr[current_top_index]) == 'Spot'
                          ? 'spotTypeSpot'
                          : 'spotTypeOthers'
                      "
                      >{{
                        getSpotType(top_sectionArr[current_top_index])
                      }} </pre
                    >
                    <pre v-if="top_sectionArr[current_top_index].hasGeohash">
in {{ getCity(top_sectionArr[current_top_index]) }}</pre
                    >
                  </span>
                </span>
                <div
                  class="image-card pointer"
                  @click="showSlideShow = !showSlideShow"
                  v-if="
                    top_sectionArr[current_top_index].resourceType === 'image'
                  "
                >
                  <img
                    src="/static/img/loader/loading-viewZzz.svg"
                    v-if="imgLoader"
                    height="70px"
                    width="70px"
                    class="logo-loader"
                  />
                  <img
                    :src="
                      getImageBackground(
                        this.top_sectionArr[current_top_index].photoId,
                        this.screenH,
                        this.screenW,
                        this.top_sectionArr[current_top_index],
                        top_sectionArr[current_top_index].keywords.includes(
                          'extabs'
                        )
                      )
                    "
                    class="image-card-image"
                    v-if="
                      !fullScreen &&
                      this.top_sectionArr[current_top_index].resourceType ===
                        'image'
                    "
                    @load="imgLoader = false"
                  />
                  <div class="inner">
                    <!--  left arrow -->
                    <div
                      v-show="
                        top_sectionArr.length > 1 &&
                        top_sectionArr[0].resourceType === 'image'
                      "
                      @click.stop="restartAnim('desc')"
                      class="arrow-container"
                    >
                      <i class="material-icons arrow-buttons"
                        >keyboard_arrow_left</i
                      >
                    </div>

                    <!--  right arrow -->
                    <div
                      class="arrow-container"
                      v-if="!fullScreen"
                      v-show="
                        top_sectionArr.length > 1 &&
                        top_sectionArr[0].resourceType === 'image'
                      "
                      @click.stop="restartAnim('inc')"
                    >
                      <i class="material-icons arrow-buttons"
                        >keyboard_arrow_right</i
                      >
                    </div>
                    <!--  /down arrow -->
                  </div>
                  <!-- top like share container -->
                  <div class="like-share-container">
                    <div
                      class="icon-container pointer"
                      @click.stop="
                        changeCnt(top_sectionArr[current_top_index], false)
                      "
                    >
                      <i
                        class="material-icons"
                        :style="
                          top_sectionArr[current_top_index].isLiked
                            ? 'color:#ff0000'
                            : ''
                        "
                        >{{
                          top_sectionArr[current_top_index].isLiked
                            ? "favorite"
                            : "favorite_outline"
                        }}</i
                      >
                    </div>
                    <div
                      class="icon-container ml-2 pointer"
                      @click.stop="
                        share(
                          top_sectionArr[current_top_index].photoId,
                          top_sectionArr[current_top_index].caption === ''
                            ? 'n'
                            : top_sectionArr[current_top_index].caption
                        )
                      "
                    >
                      <img src="/static/img/ic-reply.svg" class="share-icon" />
                    </div>
                  </div>
                  <!-- /top like share container  -->
                </div>
                <div class="video-card" v-else>
                  <div
                    style="position: relative; height: 100%; width: 100%"
                    class="video-player"
                  >
                    <iframe
                      :src="
                        getVideoLink(
                          this.top_sectionArr[current_top_index].photoId,
                          this.top_sectionArr[current_top_index].photoSourceLink
                        )
                      "
                      v-if="
                        top_sectionArr[current_top_index].photoId.match(
                          '^vmvdo'
                        )
                      "
                      frameborder="0"
                      style="
                        top: 0;
                        bottom: 0;
                        height: 90%;
                        width: 100%;
                        right: 0;
                      "
                      allow="autoplay; fullscreen"
                      allowfullscreen
                      @load="imgLoader = false"
                    ></iframe>
                    <youtube
                      id="yt_video"
                      :video-id="
                        getVideoId(
                          this.top_sectionArr[current_top_index].photoId,
                          this.top_sectionArr[current_top_index].photoSourceLink
                        )
                      "
                      :player-vars="youtubeVideoParameter"
                      :mute="muted"
                      class="video-player-youtube"
                      player-width="100%"
                      player-height="90%"
                      @pause="pause"
                      @ready="ready"
                      @playing="playing"
                      v-else
                    ></youtube>
                  </div>
                </div>
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <div class="control-section">
                    <div class="location-details">
                      <div
                        class="control-item"
                        @click="showSlideShow = !showSlideShow"
                        v-if="
                          top_sectionArr[current_top_index].resourceType ===
                          'image'
                        "
                      >
                        <img
                          src="/static/img/icons/ic-slideshow.svg"
                          class="pointer ml-1"
                        />
                        <label>Slideshow</label>
                      </div>
                      <div class="control-item" v-else>
                        <i
                          @click="fullScreen = !fullScreen"
                          class="material-icons pointer"
                          :style="!fullScreen ? '' : 'color:#febd35'"
                          >{{
                            !fullScreen ? "zoom_out_map" : "fullscreen_exit"
                          }}</i
                        >
                        <label>Fullscreen</label>
                      </div>
                      <a
                        :href="getGoogleEarthLink()"
                        :class="
                          top_sectionArr[current_top_index].hasPanoramaView
                            ? 'get-directions-link-button control-item'
                            : 'get-directions-botton-flex control-item'
                        "
                        :target="newBrowserTab()"
                        rel="noopener"
                      >
                        <img
                          src="/static/img/drone-white.svg"
                          class="heli-view-image"
                          alt="helicopter"
                        />
                        <label>Drone view</label>
                      </a>
                      <a
                        :href="top_sectionArr[current_top_index].streetViewURL"
                        v-if="top_sectionArr[current_top_index].hasPanoramaView"
                        class="street-view-link-button control-item"
                        :target="newBrowserTab()"
                        rel="noopener"
                      >
                        <!-- <i class="material-icons">location_on</i>Take me there, literally ! -->
                        <img
                          src="/static/img/street-view-doll-white.svg"
                          class="virtual-doll"
                          alt="doll"
                        />
                        <label>Virtual tour</label>
                      </a>
                      <div
                        v-if="top_sectionArr[current_top_index].hasPanoramaView"
                      >
                        <a
                          :href="getDirectionLink()"
                          :class="
                            top_sectionArr[current_top_index].hasPanoramaView
                              ? 'get-directions-link-button control-item'
                              : 'get-directions-botton-flex control-item'
                          "
                          :target="newBrowserTab()"
                          rel="noopener"
                        >
                          <i class="material-icons" style="color: #ffffff"
                            >directions</i
                          >Directions
                        </a>
                      </div>
                      <div v-else>
                        <a
                          :href="
                            top_sectionArr[current_top_index].streetViewURL
                          "
                          class="get-directions-botton-flex control-item"
                          :target="newBrowserTab()"
                        >
                          <i class="material-icons" style="color: #ffffff"
                            >directions</i
                          >Directions
                        </a>
                      </div>
                      <div
                        v-if="
                          top_sectionArr[current_top_index].resourceType ===
                          'video'
                        "
                      >
                        <div
                          :class="audioClasses()"
                          @click="muted = !muted"
                          v-if="
                            top_sectionArr[current_top_index].photoId.match(
                              '^ytvdo'
                            )
                          "
                        >
                          <label v-if="muted">Turn sound on</label>
                          <i class="material-icons white--text" v-if="muted"
                            >volume_off</i
                          >
                          <i class="material-icons white--text" v-else
                            >volume_up</i
                          >
                        </div>
                      </div>
                    </div>
                    <div class="nearby-places">
                      <FeedbackFish projectId="583bd8bafa525e" />
                      <div class="feedback">
                        <img
                          src="../../../static/img/speech-bubble.svg"
                          class="pointer feedback-speech-bubble"
                          data-feedback-fish
                          :data-feedback-fish-position="
                            top_sectionArr[current_top_index].photoId
                          "
                          :data-feedback-fish-userid="
                            isLoggedIn ? user.email : ''
                          "
                        />
                        <label>Feeback</label>
                      </div>
                      <a
                        v-if="nearBy.length > 1"
                        href="#nearby-spots"
                        class="nearby-button"
                        >DISCOVER NEARBY PLACES</a
                      >
                    </div>
                  </div>
                </div>
                <div class="photo-details">
                  <a
                    v-if="nearBy.length > 1"
                    href="#nearby-spots"
                    class="nearby-button-mobile"
                    >DISCOVER NEARBY PLACES</a
                  >
                  <div class="photographer-details">
                    <div
                      style="display: flex"
                      :class="
                        top_sectionArr[current_top_index].uploader !== 'admin'
                          ? 'pointer photographer-profile-user'
                          : 'photographer-profile'
                      "
                    >
                      <img
                        v-if="
                          top_sectionArr[current_top_index].uploader !== 'admin'
                        "
                        :src="
                          top_sectionArr[current_top_index]
                            .mediaSourceInformation.photoGrapherPic
                        "
                        @click="
                          top_sectionArr[current_top_index].uploader !== 'admin'
                            ? $router.push(
                                `/profile?selected_tab=checkins&profile_id=${top_sectionArr[current_top_index].mediaSourceInformation.photoGrapherId}`
                              )
                            : ''
                        "
                        alt="profile-photo"
                      />
                      <div class="name-container text-xs-left">
                        <div>
                          <span
                            @click="
                              top_sectionArr[current_top_index].uploader !==
                              'admin'
                                ? $router.push(
                                    `/profile?selected_tab=checkins&profile_id=${top_sectionArr[current_top_index].mediaSourceInformation.photoGrapherId}`
                                  )
                                : ''
                            "
                            >{{
                              cropUsername(
                                top_sectionArr[current_top_index]
                                  .mediaSourceInformation.photoGrapherName
                              )
                            }}</span
                          >
                          <span @click="$modal.show('license-modal')">©</span>
                        </div>
                      </div>
                    </div>
                    <FeedbackFish projectId="583bd8bafa525e" />
                    <img
                      src="../../../static/img/speech-bubble.svg"
                      height="25px"
                      class="pointer feedback-speech-bubble"
                      data-feedback-fish
                      :data-feedback-fish-position="
                        top_sectionArr[current_top_index].photoId
                      "
                      :data-feedback-fish-userid="isLoggedIn ? user.email : ''"
                    />
                  </div>
                </div>
              </div>
            </div>

            <!-- OLD ONE FOR VIDEO -->
            <!-- top -->
            <div
              class="details-container"
              v-if="
                this.top_sectionArr[current_top_index].resourceType == 'video'
              "
            >
              <div class="top-section-container" v-if="fullScreen">
                <iframe
                  :src="
                    getVideoLink(
                      this.top_sectionArr[current_top_index].photoId,
                      this.top_sectionArr[current_top_index].photoSourceLink
                    )
                  "
                  v-if="
                    top_sectionArr[current_top_index].photoId.match('^vmvdo')
                  "
                  frameborder="0"
                  style="top: 0; bottom: 0; height: 90%; width: 100%; right: 0"
                  allow="autoplay; fullscreen"
                  allowfullscreen
                  @load="imgLoader = false"
                ></iframe>
                <youtube
                  id="yt_video"
                  :video-id="
                    getVideoId(
                      this.top_sectionArr[current_top_index].photoId,
                      this.top_sectionArr[current_top_index].photoSourceLink
                    )
                  "
                  :player-vars="youtubeVideoParameter"
                  :mute="muted"
                  class="video-player-youtube"
                  player-width="100%"
                  player-height="90%"
                  @pause="pause"
                  @ready="ready"
                  @playing="playing"
                  v-else
                ></youtube>

                <!-- footer -->
                <div
                  class="fullscreen-footer"
                  v-if="showFooter"
                  :style="fullScreen ? 'z-index:2000' : ''"
                >
                  <div class="footer-content">
                    <div class="like-share-fullscreen-container pointer">
                      <i
                        @click="fullScreen = !fullScreen"
                        class="material-icons pointer"
                        :style="
                          !fullScreen ? 'font-size: 1.4em' : 'color:#febd35'
                        "
                        >{{
                          !fullScreen ? "zoom_out_map" : "fullscreen_exit"
                        }}</i
                      >
                      <FeedbackFish projectId="583bd8bafa525e" />
                      <img
                        src="../../../static/img/speech-bubble.svg"
                        height="25px"
                        class="pointer feedback-speech-bubble"
                        data-feedback-fish
                        :data-feedback-fish-position="
                          top_sectionArr[current_top_index].photoId
                        "
                        :data-feedback-fish-userid="
                          isLoggedIn ? user.email : ''
                        "
                      />
                    </div>
                  </div>
                </div>
                <!-- /footer -->
              </div>
            </div>
            <!-- /top -->

            <!-- neaby spots -->
            <!-- nearby -->
            <div
              v-if="
                nearBy.length > 1 &&
                this.top_sectionArr[current_top_index].resourceType == 'image'
              "
              class="near-height"
              id="nearby-spots"
            >
              <!-- slide img -->
              <div class="nearby-images">
                <div
                  class="text-xs-left"
                  v-if="
                    nearBy[0] !== $router.currentRoute.params.id &&
                    nearBy.length !== 1
                  "
                >
                  Nearby spots
                </div>
                <div id="nearby" @scroll="getScroll()" class="scrollmenu">
                  <div
                    class="a-tag"
                    v-show="image.photoId != $route.params.id"
                    v-for="(image, index) in nearBy"
                    :key="index"
                    :style="{
                      paddingRight: `${
                        index === nearBy.length - 1 ? '20px' : '0px'
                      }`,
                      paddingLeft: `${index === 0 ? '0px' : '20px'}`,
                    }"
                  >
                    <div
                      @click="
                        $router.push(`/id/${image.photoId}?inapp=true`);
                        $forceUpdate();
                      "
                      v-if="!image.photoId.match('^vmvdo')"
                    >
                      <v-lazy-image
                        class="pointer"
                        style="object-fit: cover"
                        :src="nearbyViewzzzImage(image.photoId, image)"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <!-- /slide img -->
            </div>
            <div v-if="nearBy.length === 0"></div>
            <!-- /nearby -->
            <!-- /neaby spots -->
          </div>
          <!-- /OLD:2 -->
        </div>
      </div>
      <!-- sticky footer -->
      <div class="sticky-footer" v-if="!fullScreen">
        <div class="navigations">
          <a href="https://www.withaview.co/" class="logo" v-if="showHomeIcon">
            <button>
              <img
                loading="lazy"
                height="24"
                src="../../../static/img/vectorpaint.svg"
              />
            </button>
            <span>Home</span>
          </a>
          <button @click="goToHome()" class="list-view-btn" v-else>
            <i class="material-icons"> reorder</i>
            <span @click="goToHome()">List</span>
          </button>
        </div>
        <div class="photo-description">
          <span class="caption pb-2">
            {{
              this.top_sectionArr[current_top_index].caption
                ? this.top_sectionArr[current_top_index].caption
                : ""
            }}
          </span>
          <span class="location">
            <pre
              :class="
                getSpotType(top_sectionArr[current_top_index]) == 'Spot'
                  ? 'spotTypeSpot'
                  : 'spotTypeOthers'
              "
              >{{ getSpotType(top_sectionArr[current_top_index]) }} </pre
            >
            <pre v-if="top_sectionArr[current_top_index].hasGeohash">
in {{ getCity(top_sectionArr[current_top_index]) }}</pre
            >
          </span>
        </div>
        <div
          style="
            height: 100%;
            align-items: center;
            justify-content: flex-end;
            width: 100%;
            display: flex;
          "
        >
          <a
            class="check-price-btn"
            :href="top_sectionArr[current_top_index].propertyLink"
            v-if="top_sectionArr[current_top_index].propertyLink"
            :target="screenW > 768 ? '_blank' : '_self'"
            nofollow
            >Check Price</a
          >
          <a
            class="read-review-btn"
            :href="top_sectionArr[current_top_index].fourSquareVenueUrl"
            v-if="top_sectionArr[current_top_index].fourSquareVenueUrl"
            :target="screenW > 768 ? '_blank' : '_self'"
            nofollow
            >Read review</a
          >
          <button
            :class="`travel-list-btn ${
              top_sectionArr[current_top_index].isCheckedin ? 'checked' : 'add'
            }`"
          >
            <i class="material-icons mr-2">
              {{
                top_sectionArr[current_top_index].isCheckedin ? "check" : "add"
              }}
            </i>
            <span
              @click="changeCntCheckin(top_sectionArr[current_top_index])"
              >{{
                top_sectionArr[current_top_index].isCheckedin
                  ? "On my travel list"
                  : "Save to travel list"
              }}</span
            >
          </button>
        </div>
      </div>
      <!-- /sticky footer -->
    </div>
  </div>
</template>

<script>
let vm;
import platform from "platform";
import imageLinks from "../../mixin/imageLinks";
import cropUsername from "../../mixin/cropUsername";
import { isMobileSafari } from "../../helper/identifySafariMobile";
import { mapGetters, mapMutations } from "vuex";
import bottomMenu from "../../components/common/bottomMenu.vue";
import { ele } from "@/helper/gen";
import geo from "geo-hash";
import haversine from "haversine";
import searchContainer from "../common/searchContainer.vue";
import loader from "../../components/loader.vue";
//
import share_m from "../../mixin/share";
import { isUrl } from "../../helper/valUrl";
//
import configurations from "../../configurations";
//
import { FeedbackFish } from "@feedback-fish/vue";
//
import slideShow from "../common/slideshow.vue";

let cloudinarySettings = configurations.cloudinary_settings;
export default {
  name: "viewzzz-image-details",
  metaInfo() {
    return {
      title: this.getPageTitle(),
      titleTemplate: null,
      meta: [
        { charset: "utf-8" },
        {
          name: "description",
          content: this.getPageDescription(),
        },
        {
          property: "og:title",
          content: this.getOgTitle(),
        },
        {
          property: "og:description",
          content:
            "Everything's better with A view. Discover the most beautiful Hotels, Restaurants & Bars with A view.",
        },
        { property: "og:url", content: window.location.href, vmid: "og:url" }, // here it is just ngrok for my test
        {
          property: "og:site_name",
          content: "with A view",
        },
        {
          property: "og:image",
          content: this.getOgImage(),
        },
        {
          property: "og:image:url",
          content: this.getOgImage(),
        },
        { property: "og:image:secure_url", content: this.getOgImage() },
        {
          property: "og:image:type",
          content: "image/jpeg",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:site",
          content: "@withaview_co",
        },
        {
          name: "twitter:creator",
          content: "@withaview_co",
        },
        {
          name: "twitter:url",
          content: `${window.location.href}`,
        },
        {
          name: "twitter:title",
          content: `${this.getOgTitle()}`,
        },
        {
          name: "twitter:description",
          content:
            "Everything's better with A view. Discover the most beautiful Hotels, Restaurants & Bars with A view.",
        },
        {
          name: "twitter:image",
          content: `${this.getOgImage()}`,
        },
        {
          property: "fb:app_id",
          content: "172987823496136",
        },
      ],
    };
  },
  // mixins
  mixins: [imageLinks, share_m, cropUsername],
  data() {
    return {
      pageLoader: true,
      platform: platform.name,
      loaderVal: 0,
      top_index: 0,
      imgLoader: true,
      top_sectionArr: [],
      currentImageData: null,
      changeFromSelect: false,
      fullScreen: false,
      current_top_index: 0,
      top_section: {},
      animPlay: true,
      limit: 10,
      screenH: 0,
      screenW: 0,
      locDetails: {},
      wishlistStatus: `add to my wishlist`, // default value
      checkInStatus: `check-in`, // default value
      imageInfo: {},
      addedToWishlist: false,
      checkedin: false,
      showFooter: true,
      monSelectOpts: false,
      durSelectOpts: false,
      muted: true,
      playVideo: false,
      playVideoWindow: true,
      youtubeVideoParameter: {
        autoplay: 1,
        controls: 1,
        loop: 1,
        playsinline: 1,
        modestbranding: 1,
      },
      showSlideShow: false,
      lastScrollPosition: 0,
      showNavbar: true,
      filterViewType: "Everything is better ",
      showHomeIcon: true,
    };
  },
  watch: {
    selected_mon: {
      handler() {
        this.top_sectionArr_compute();
      },
    },
    selected_dur: {
      handler() {
        this.top_sectionArr_compute();
      },
    },
    // changes when ask-to-add-to-wishlist is clicked
    "$store.state.common.toggleForAddToWishlist": {
      handler() {
        localStorage.removeItem("openDirections");
        if (Object.keys(this.imageInfo).length !== 0) {
          if (this.imageInfo.isLiked === false) {
            this.changeCnt(this.imageInfo, false);
          }
          this.$modal.hide("ask-to-add-to-wishlist");
        }
      },
    },

    // when location of user is fetched
    "$store.state.gen.finalUserLocation": () => {
      vm.getLocationImage();
    },

    // changes when clicked on 'nearby viewzzz'
    "$route.params.id": () => {
      vm.getDet(vm.$route.params.id);
      vm.goBackToTop();
    },
  },
  computed: {
    ...mapGetters([
      "fetchingNearby",
      "isbottomMenuOpen", //
      "user",
      "finalUserLocation",
      "isLoggedIn",
      "fetchLocLoader",
      "nearBy",
      "user",
    ]),

    // check if device is mobile - safari
    checkIfMobileSafari() {
      let deviceIsSafriMobile = isMobileSafari();
      return deviceIsSafriMobile;
    },
  },
  components: {
    bottomMenu,
    FeedbackFish,
    loader,
    slideShow,
    searchContainer,
  },

  // *********************** route navigation **********************
  beforeRouteUpdate(to, from, next) {
    if (this.showFooter === false && localStorage.getItem("path") === null) {
      localStorage.removeItem("path");
      localStorage.removeItem("openDirections");
      vm.backToDetails();
      next(false);
    } else {
      localStorage.removeItem("path");
      localStorage.removeItem("openDirections");
      let localStorageElem = JSON.parse(localStorage.getItem("homePageImages"));
      if (localStorageElem != null) {
        let obj =
          localStorageElem.filteredImagesArr[localStorageElem.swipeIndex];

        obj.isLiked = vm.imageInfo.isLiked;
        obj.isCheckedin = vm.imageInfo.isCheckedin;
        obj.likes = vm.imageInfo.likes;
        obj.checkins = vm.imageInfo.checkins;
        localStorageElem.filteredImagesArr[localStorageElem.swipeIndex] = obj;
        localStorage.setItem(
          "homePageImages",
          JSON.stringify(localStorageElem)
        );
      }
      next();
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.showFooter === false && localStorage.getItem("path") === null) {
      localStorage.removeItem("path");
      localStorage.removeItem("openDirections");
      vm.backToDetails();
      next(false);
    } else {
      let localStorageElem = JSON.parse(localStorage.getItem("homePageImages"));
      if (localStorageElem != null) {
        let obj =
          localStorageElem.filteredImagesArr[localStorageElem.swipeIndex];
        if (obj !== undefined) {
          obj.isLiked = vm.imageInfo.isLiked;
          obj.isCheckedin = vm.imageInfo.isCheckedin;
          obj.likes = vm.imageInfo.likes;
          obj.checkins = vm.imageInfo.checkins;
          localStorageElem.filteredImagesArr[localStorageElem.swipeIndex] = obj;

          localStorage.setItem(
            "homePageImages",
            JSON.stringify(localStorageElem)
          );
        }
      }
      localStorage.removeItem("openDirections");
      localStorage.removeItem("path");
      next();
    }
  },
  // *********************** /route navigation **********************
  mounted() {
    vm = this;
    // if (this.platform.toLowerCase() === "safari") {
    //   setInterval(() => {
    //     if (this.animPlay) {
    //       if (this.loaderVal == 100) {
    //         this.reccursiveAnimationCall();
    //         this.loaderVal = 0;
    //       } else {
    //         this.loaderVal += 10;
    //       }
    //     }
    //   }, 3000);
    // }
    setTimeout(() => {
      this.getDet(this.$route.params.id);
    }, 1000);
    this.$store.commit("getLocationFinal");

    this.screenW = screen.width;
    this.screenH = screen.height;
    let obj = JSON.parse(JSON.stringify(vm.$route.query));
    if (!!obj.inapp) {
      this.showHomeIcon = false;
    } else {
      this.showHomeIcon = true;
    }
  },
  created() {
    window.addEventListener("blur", () => {
      this.videoPlayPauseWindow();
    });
    window.addEventListener("focus", () => {
      this.videoPlayPauseWindow();
    });
    let obj = JSON.parse(JSON.stringify(this.$route.query));
    this.filterViewType = obj.viewType ? obj.viewType : "Everything is better";
  },
  beforeDestroy() {
    window.removeEventListener("blur", () => {
      this.videoPlayPauseWindow();
    });
    window.removeEventListener("focus", () => {
      this.videoPlayPauseWindow();
    });
  },
  methods: {
    ...mapMutations(["operationOnPhoto", "getLocation", "snackbar_alert"]),
    getPageTitle() {
      if (this.currentImageData) {
        let caption =
          this.currentImageData.caption.length > 40
            ? this.currentImageData.caption.substring(0, 40) + ".."
            : this.currentImageData.caption;
        let spot = this.getSpotType(this.currentImageData);
        if (caption.length > 1 && spot !== "Spot") {
          return `${caption} | ${spot}`;
        } else if (caption.length > 1 && spot === "Spot") {
          return `${caption} | ${spot}`;
        } else if (caption.length <= 1 && spot !== "Spot") {
          return `${spot}`;
        } else {
          return "Spot with A view";
        }
      } else {
        return "with a view";
      }
    },
    getPageDescription() {
      if (this.currentImageData) {
        let spot = this.getSpotType(this.currentImageData);
        let city = this.getCity(this.currentImageData);
        let country = this.currentImageData.aboutLoc.country
          ? this.currentImageData.aboutLoc.country
          : "";
        return `Discover this beautiful ${spot} with a view in ${city}${
          city === country ? "" : ", " + country
        } , exact location, travel tip and nearby spots`;
      }
    },
    getOgTitle() {
      let imgTitle = "";
      if (this.currentImageData) {
        if (this.currentImageData.caption.length > 1) {
          if (this.currentImageData.spotType.length !== 1) {
            let st = this.getSpotType(this.currentImageData);
            imgTitle = `Check out this beautiful ${st} with A view!`;
          } else {
            imgTitle = `Check out this beautiful spot with A view`;
          }
        } else {
          if (this.currentImageData.spotType.length !== 1) {
            let st = this.getSpotType(this.currentImageData);
            imgTitle = `${st} with a view`;
          } else {
            imgTitle = "Spot with A view";
          }
        }
      } else {
        imgTitle = "Spot with A view";
      }
      return imgTitle;
    },
    getOgDescription() {
      if (this.currentImageData) {
        return this.currentImageData.pic_desc;
      } else {
        return "";
      }
    },
    getOgImage() {
      let imageData = this.currentImageData;
      if (imageData) {
        if (imageData.resourceType === "image") {
          if (imageData.photoId.match("^fse")) {
            let link = this.top_sectionArr[0].photoSourceLink;
            let photoLink = link.replace("original", "width1200");
            return photoLink;
          } else if (!!imageData.propertyLink) {
            if (imageData.photoSourceLink.includes("w=")) {
              let photoLink = new URL(imageData.photoSourceLink);
              let baseURL = photoLink.origin;
              let path = photoLink.pathname;
              photoLink.searchParams.set("w", 1200);
              let search = photoLink.search;
              return baseURL + path + search;
            } else {
              return imageData.photoSourceLink;
            }
          } else {
            return `https://res.cloudinary.com/${configurations.cloudinary_cloudName}/image/upload/w_1200,${cloudinarySettings},dpr_auto/${configurations.cloudinary_preset}/${imageData.photoId}`;
          }
        } else {
          return `https://res.cloudinary.com/${configurations.cloudinary_cloudName}/image/upload/w_1200,${cloudinarySettings}/${configurations.cloudinary_preset}/IMG_9689_fkookv_aywwr4`;
        }
      } else {
        return "";
      }
    },
    closeSlideShow() {
      this.showSlideShow = false;
    },
    pause() {
      if (this.player) {
        this.player.pauseVideo();
      }
    },
    playing() {
      if (this.player) {
        this.player.playVideo();
      }
    },
    videoPlayPause() {
      this.playVideo = !this.playVideo;
      if (this.playVideo) {
        this.playing();
      } else {
        this.pause();
      }
    },
    videoPlayPauseWindow() {
      this.playVideoWindow = !this.playVideoWindow;
      if (this.playVideoWindow) {
        this.playing();
      } else {
        this.pause();
      }
    },
    ready(event) {
      this.player = event.target;
    },
    audioClasses() {
      if (this.muted) {
        return "audio-button-sound-off";
      } else {
        return "audio-button-sound-on";
      }
    },
    getVideoLink(videoId, videoLink) {
      let timestamp = "";
      if (videoLink.indexOf("#") !== -1) {
        timestamp = "#" + videoLink.split("#")[1];
      }
      var id = videoId.substring(videoId.indexOf("_") + 1);
      return `https://player.vimeo.com/video/${id}?loop=1${timestamp}&title=0&byline=0&portrait=0`;
    },
    getVideoId(videoId, videoLink) {
      var id = videoId.substring(videoId.indexOf("_") + 1);
      const parameters = new URL(videoLink).searchParams;
      if (parameters.get("t") !== null || parameters.get("start") !== null) {
        if (parameters.get("t")) {
          this.youtubeVideoParameter["start"] = parameters.get("t");
        } else {
          this.youtubeVideoParameter["start"] = parameters.get("start");
        }
      }
      console.log("Link", id);
      return id;
    },
    getScrollPos() {
      let elem = ele(`image-details-container`);
      let containerScrollPos = elem.scrollTop;
      if (containerScrollPos > 500) {
        if (containerScrollPos - this.lastScrollPosition < 0) {
          document.getElementById("sticky-search-bar").style.top = "0px";
        } else {
          document.getElementById("sticky-search-bar").style.top = "-100%";
        }
        this.lastScrollPosition = containerScrollPos;
      } else {
        document.getElementById("sticky-search-bar").style.top = "0px";
      }
    },
    newBrowserTab() {
      if (this.screenW > 768) {
        return "_blank";
      } else {
        return "";
      }
    },
    getImageBackground(id, screenHeight, screenWidth, photoDetails, hasExtabs) {
        if (id.match("^fse")) {
          let link = photoDetails.photoSourceLink;
          let photoLink = link.replace(
            "original",
            `height${(screenHeight * 0.85).toFixed(0)}`
          );
          return photoLink;
        } else if (!!photoDetails.propertyLink) {
          if (photoDetails.photoSourceLink.includes("h=")) {
            let photoLink = new URL(photoDetails.photoSourceLink);
            let baseURL = photoLink.origin;
            let path = photoLink.pathname;
            photoLink.searchParams.set("h", this.screenH*0.60);
            let search = photoLink.search;
            return baseURL + path + search;
          }
          return photoDetails.photoSourceLink;
        } else {
          if (!!photoDetails.flickrImageLink) {
            if (screenWidth > 1200 && screenWidth < 1600) {
              return photoDetails.flickrImageLink.replace("_o.", "_h.");
            } else if (screenWidth > 1600) {
              return photoDetails.flickrImageLink.replace("_o.", "_k.");
            } else if (screenWidth < 1200 && screenWidth > 800) {
              return photoDetails.flickrImageLink.replace("_o.", "_b.");
            } else if (screenWidth <= 800) {
              return photoDetails.flickrImageLink.replace("_o.", "_c.");
            }
          } else {
            return `https://res.cloudinary.com/${
              configurations.cloudinary_cloudName
            }/image/upload/h_${(screenHeight * 0.85).toFixed(
              0
            )},${cloudinarySettings},dpr_auto/${
              configurations.cloudinary_preset
            }/${id}`;
          }
        }
    },
    top_sectionArr_compute() {
      let arr = [];
      if (this.top_section.pics !== undefined) {
        for (let i in this.top_section.pics) {
          if (i === this.selected_mon) {
            for (let j in this.top_section.pics[i]) {
              if (j === this.selected_dur) {
                for (let k in this.top_section.pics[i][j]) {
                  let obj = this.top_section.pics[i][j][k];
                  obj.mon = i;
                  obj.dur = j;
                  arr.unshift(obj);
                }
              } else {
                for (let k in this.top_section.pics[i][j]) {
                  let obj = this.top_section.pics[i][j][k];
                  obj.mon = i;
                  obj.dur = j;
                  arr.push(obj);
                }
              }
            }
          } else {
            for (let j in this.top_section.pics[i]) {
              for (let k in this.top_section.pics[i][j]) {
                let obj = this.top_section.pics[i][j][k];
                obj.mon = i;
                obj.dur = j;
                arr.push(obj);
              }
            }
          }
        }
        // arr = this.top_section.pics[this.selected_mon][this.selected_dur]
      }
      this.current_top_index = 0;
      this.top_sectionArr = arr;
      this.currentImageData = arr[0];
    },
    goToHome() {
      let lsElem = JSON.parse(localStorage.getItem("homePageImages"));
      if (lsElem !== null) {
        if (screen.width < 768) {
          lsElem.isModeSwipe = true;
        } else {
          lsElem.isModeSwipe = false;
        }
        lsElem.swipeIndex = 0;
        localStorage.setItem("homePageImages", JSON.stringify(lsElem));
      }
      if (JSON.parse(localStorage.getItem("fromPath")) !== null) {
        if (JSON.parse(localStorage.getItem("fromPath")).loc !== undefined) {
          this.$router.push(
            `/?loc=${JSON.parse(localStorage.getItem("fromPath")).loc}`
          );
        } else {
          this.$router.push("/?loc=Worldwide");
        }
      } else {
        this.$router.push("/?loc=Worldwide");
      }
    },
    animation(status) {
      let fl = ele(`f-l`);
      let fr = ele(`f-r`);
      if (fl != null && fr != null && platform !== "safari") {
        fl.style.webkitAnimationPlayState = status;
        fl.style.animationPlayState = status;
        fr.style.webkitAnimationPlayState = status;
        fr.style.animationPlayState = status;
        if (status === "paused") {
          this.animPlay = false;
        } else {
          this.animPlay = true;
        }
      } else {
        if (status === "paused") {
          this.animPlay = false;
        } else {
          this.animPlay = true;
        }
      }
    },
    restartAnim(action) {
      this.loaderVal = 0;
      if (action === "inc") {
        if (this.current_top_index < this.top_sectionArr.length) {
          if (this.current_top_index < this.top_sectionArr.length - 1) {
            this.current_top_index += 1;
            this.top_index += 1;
          } else {
            this.current_top_index = 0;
            this.top_index = 0;
          }
        }

        let elem = ele(`loader`);

        if (elem !== null) {
          elem.style.display = "none";
          setTimeout(() => {
            elem.style.display = "flex";
          }, 1);
        }
      } else {
        if (this.current_top_index >= 0) {
          if (this.current_top_index > 0) {
            this.current_top_index -= 1;
            this.top_index -= 1;
          } else {
            this.current_top_index = this.top_sectionArr.length - 1;
            this.top_index = this.top_sectionArr.length - 1;
          }

          let elem = ele(`loader`);
          if (elem !== null) {
            elem.style.display = "none";
            setTimeout(() => {
              elem.style.display = "flex";
            }, 1);
          }
        }
      }
      // this.selected_mon = this.top_sectionArr[this.current_top_index].mon;
      // this.selected_dur = this.top_sectionArr[this.current_top_index].dur;
    },
    reccursiveAnimationCall() {
      if (this.top_index < this.top_sectionArr.length - 1) {
        this.top_index++;
      } else {
        this.top_index = 0;
      }
      let elem = ele(`loader`);
      if (this.animPlay) {
        if (elem !== null) {
          elem.style.display = "none";
          setTimeout(() => {
            elem.style.display = "flex";
          }, 1);
        }

        let arr = this.top_sectionArr;
        if (this.current_top_index >= arr.length - 1) {
          this.current_top_index = 0;
        } else {
          this.current_top_index += 1;
        }
      }
    },
    getScroll() {
      console.log(this.imageInfo);
      let elem = document.getElementById("nearby");
      if (elem.scrollLeft > elem.scrollWidth - 700 && !this.fetchingNearby) {
        console.log("this.imageInfo", this.imageInfo);
        this.$store.commit("getNearbyPhotos", {
          geohash: this.imageInfo.shareSpotLocation.geohash,
          startAt: this.nearBy.length,
          limit: this.limit,
          photoId: this.imageInfo.photoId,
          isProperty: this.imageInfo.isProperty,
          masterPropertyId: this.imageInfo.masterPropertyId,
        });
      }
    },

    // called when distance is available and clicked on the distance
    dummyFunc() {
      this.$store.state.common.imageDetParticular = this.imageInfo;
      this.$store.state.common.imageDetParticular.id = this.$route.params.id;
      this.$modal.show("ask-to-add-to-wishlist");
    },

    //
    goToUpload() {
      //alert(this.$store.state.auth.isLoggedIn)
      if (this.$store.state.auth.isLoggedIn) {
        //alert(`0`)
        this.$router.push("/upload-0");
      } else {
        //alert(`1`)
        this.$router.push("/login");
        this.$store.commit("snackbar_alert", {
          msg: "Please sign in to complete your desired action.",
        });
      }
    },

    // set scrollTop position to 0
    goBackToTop() {
      let e1 = document.getElementById("back-key");
      e1.scrollIntoView();
    },
    //
    validateUrl(url) {
      return isUrl(url);
    },
    //
    //
    async getDet(paramId) {
      //
      let topImageSection = null;
      let particularPhotoDetails = null;
      let vm = this;
      let res;
      vm.pageLoader = true;
      if (localStorage.getItem("imgDet_status") !== "comingFromApp") {
        topImageSection = this.$store.dispatch("_top_image_section", {
          photoId: paramId,
          uid: vm.user.uid,
          isLoggedIn: vm.$store.state.auth.isLoggedIn,
        });
        particularPhotoDetails = this.$store.dispatch("getImageDetails", {
          pid: paramId,
          uid: vm.user.uid,
          radius: 10,
          isLoggedIn: vm.$store.state.auth.isLoggedIn,
        });
      } else {
        particularPhotoDetails = this.$store.dispatch("getImageDetails", {
          pid: paramId,
          uid: vm.user.uid,
          radius: 10,
          isLoggedIn: vm.$store.state.auth.isLoggedIn,
        });
        // this.imageInfo = {};
        // this.imageInfo = res;
        topImageSection = this.$store.dispatch("_top_image_section", {
          photoId: paramId,
          uid: vm.user.uid,
          isLoggedIn: vm.$store.state.auth.isLoggedIn,
        });
        // this.top_sectionArr_compute();
      }
      let imageData = await Promise.all([
        topImageSection,
        particularPhotoDetails,
      ]);
      this.top_section = imageData[0];
      this.top_sectionArr_compute();
      res = imageData[1];
      this.imageInfo = {};
      this.imageInfo = res;
      vm.pageLoader = false;

      let ischeckedIn = res.isCheckedIn;
      delete this.imageInfo["isCheckedIn"];
      this.imageInfo.isCheckedin = ischeckedIn;

      // wishlist btn status
      // if (this.imageInfo.isLiked) {
      //   vm.wishlistStatus = `already on your wishlist`;
      // } else {
      //   vm.wishlistStatus = `add to my wishlist`;
      // }
      //
      if (localStorage.getItem("operationOnPhoto") != null) {
        if (this.imageInfo.isLiked === false) {
          this.changeCnt();
        }
      }

      // checkin btn status
      // if (this.imageInfo.isCheckedin) {
      //   vm.checkInStatus = `you are already checked in here`;
      // } else {
      //   vm.checkInStatus = `check-in`;
      // }

      if (
        this.finalUserLocation !== "" &&
        this.finalUserLocation !== undefined &&
        res.hasGeohash !== false
      ) {
        let d1Lon = geo.decode(this.finalUserLocation);
        let d1 = { latitude: d1Lon.lat, longitude: d1Lon.lon };
        let d2Lon = geo.decode(vm.imageInfo.shareSpotLocation.geohash);
        let d2 = { latitude: d2Lon.lat, longitude: d2Lon.lon };

        let distance = haversine(d1, d2);
        this.imageInfo.distance = `${distance.toFixed(0)} km`;
        if (this.imageInfo.distance === undefined) {
          this.imageInfo.distance = "NA";
        }
      } else {
        if (res.hasGeohash === false) {
          this.imageInfo.distance = "NA";
        } else {
          this.imageInfo.distance = "-- km";
        }
      }
      // setTimeout(() => {
      //   this.$store.commit("getMarkerOnCurrentLoc", {
      //     isLocAvailable: this.imageInfo.hasGeohash,
      //     geohash: this.imageInfo.shareSpotLocation.geohash
      //   });
      // }, 100);

      // setTimeout(() => {
      //   if (localStorage.getItem("openDirections") != null) {
      //     if (this.imageInfo.isLiked !== true) {
      //       this.changeCnt();
      //     }
      //   }
      // }, 500);
      this.$store.commit("getNearbyPhotos", {
        geohash: res.shareSpotLocation.geohash,
        startAt: 0,
        limit: vm.limit,
        photoId: res.photoId,
        isProperty: res.isProperty,
        masterPropertyId: res.masterPropertyId,
      });
      vm.pageLoader = false;
    },
    getLocationImage() {
      if (
        this.finalUserLocation !== "" &&
        this.finalUserLocation !== undefined &&
        this.imageInfo.shareSpotLocation !== undefined
      ) {
        let d1, d2;
        if (this.imageInfo.shareSpotLocation.geohash !== "") {
          let d = this.finalUserLocation;
          let d1Lon = geo.decode(d);
          d1 = { latitude: d1Lon.lat, longitude: d1Lon.lon };
          let d2Lon = geo.decode(vm.imageInfo.shareSpotLocation.geohash);
          d2 = { latitude: d2Lon.lat, longitude: d2Lon.lon };
        }

        let distance = haversine(d1, d2);
        let isM = false;
        if (distance.toFixed(0) === "0") {
          isM = true;
          distance = haversine(d1, d2, { unit: "meter" });
        }
        this.imageInfo.distance = `${distance.toFixed(0)} ${
          isM ? " m" : " km"
        }`;
        this.$forceUpdate();
      } else {
        this.imageInfo.distance = "-- km";
        this.$forceUpdate();
      }
    },
    fadeOpen() {
      if (this.isbottomMenuOpen) {
        setTimeout(() => {
          ele(`bottom-menu`).style.opacity = 1;
        }, 100);
      }
    },
    async abc(anc) {
      console.log("CALLED IT", anc);
    },
    async changeCnt(obj, imageClick) {
      console.log("CAlled");
      if (!this.$store.state.gen.isAPICalling) {
        let vm = this;
        console.log("comming in");
        if (this.isLoggedIn) {
          console.log("coming in");
          let img = obj; //this.imageInfo
          if (imageClick && img.isLiked === true) {
          } else {
            if (img.isLiked === false) {
              vm.wishlistStatus = `added to my wishlist`;
              img.isLiked = true;
              img.likes++;
              a;
            } else {
              vm.wishlistStatus = `add to my wishlist`;
              img.isLiked = false;
              img.likes--;
            }
            this.$store.commit("UPDATE_IS_API_CALLING", { val: true });
            let status = await vm.$store.dispatch("operationOnPhoto", {
              pid: obj.photoId === undefined ? obj.id : obj.photoId,
              uid: vm.user.uid,
              operation: "like",
              uploaderId: obj.mediaSourceInformation.photoGrapherId,
              action: img.isLiked ? "add" : "remove",
            });
            this.$store.commit("UPDATE_IS_API_CALLING", { val: false });
            this.updateLS(img);
          }
        } else {
          this.$store.commit("snackbar_alert", {
            msg: " Please sign in to complete your desired action.",
          });
          this.$router.push("/login");
        }
      }
    },
    updateLS(img) {
      let localStorageElem = JSON.parse(localStorage.getItem("homePageImages"));
      if (localStorageElem != null) {
        for (let i in localStorageElem.filteredImagesArr) {
          if (
            (localStorageElem.filteredImagesArr[i].id = vm.$route.params.id)
          ) {
            // let obj = localStorageElem.filteredImagesArr[i]
            localStorageElem.filteredImagesArr[i].likes = img.likes;
            localStorageElem.filteredImagesArr[i].isLiked = img.isLiked;
            localStorageElem.filteredImagesArr[i].checkins = img.checkins;
            localStorageElem.filteredImagesArr[i].isCheckedin = img.isCheckedin;
            localStorage.setItem(
              "homePageImages",
              JSON.stringify(localStorageElem)
            );
            break;
          }
        }
      }
    },
    async changeCntCheckin(obj) {
      if (!this.$store.state.gen.isAPICalling) {
        let vm = this;
        if (this.isLoggedIn) {
          let img = obj; // this.imageInfo
          if (img.isCheckedin === false) {
            vm.checkInStatus = `you are checked in`;
            img.isCheckedin = true;
            img.checkins++;
          } else {
            vm.checkInStatus = `check-in`;
            img.isCheckedin = false;
            img.checkins--;
          }
          this.$store.commit("UPDATE_IS_API_CALLING", { val: true });
          let status = await vm.$store.dispatch("operationOnPhoto", {
            pid: obj.photoId,
            uid: vm.user.uid,
            operation: "checkin",
            uploaderId: img.mediaSourceInformation.photoGrapherId,
            action: img.isCheckedin ? "add" : "remove",
          });
          this.$store.commit("UPDATE_IS_API_CALLING", { val: false });

          this.updateLS(img);
        } else {
          this.$store.commit("snackbar_alert", {
            msg: "Please sign in to complete your desired action.",
          });
          this.$router.push("/login");
        }
      }
    },

    easeOut(time) {
      setTimeout(() => {
        let currentScrollPosition = ele(`image-container`).scrollLeft;
        let upperLimit = ele(`image-main`).clientWidth - vm.screenW;
        let lowerLimit = 0;
        let scrollWidth = upperLimit / 2;
        if (
          currentScrollPosition >= upperLimit - 10 ||
          currentScrollPosition <= lowerLimit + 10
        ) {
          TweenMax.to("#image-container", 1, {
            scrollLeft: scrollWidth,
            ease: Bounce.easeOut,
          });
        }
      }, time);
    },
    getDirectionLink() {
      let coord = geo.decode(vm.imageInfo.shareSpotLocation.geohash);
      return `https://www.google.com/maps/dir//${coord.lat},${coord.lon}/`;
    },
    getGoogleEarthLink() {
      let coord = geo.decode(vm.imageInfo.shareSpotLocation.geohash);
      return `https://earth.google.com/web/search/${coord.lat},${coord.lon}/`;
    },
    backToDetails() {
      let pathFromLS = localStorage.getItem("path");
      if (pathFromLS === null) {
      } else {
        this.$router.push(pathFromLS);
      }
    },
    getSpotType(filterArr) {
      let defaultSpotType = "Spot";
      if (filterArr != undefined) {
        if (filterArr.spotType.length == 0) {
          return defaultSpotType;
        } else {
          if (
            filterArr.spotType.length == 1 &&
            filterArr.spotType[0] == "all"
          ) {
            return defaultSpotType;
          } else {
            let priorityList = [
              "rooftop bar",
              "bar",
              "airbnb",
              "apartment",
              "hotel room",
              "room",
              "hotel",
              "infinity pool",
              "pool",
              "restaurant",
              "cafe",
            ];
            let spotType = defaultSpotType;
            let i;
            for (i = 0; i < priorityList.length; i++) {
              if (filterArr.spotType.includes(priorityList[i])) {
                spotType = priorityList[i];
                break;
              }
            }
            return this.getCapitalizedString(spotType);
          }
        }
      } else {
        return defaultSpotType;
      }
    },
    getCapitalizedString(str) {
      let capitalizedString = str.charAt(0).toUpperCase() + str.slice(1);
      return capitalizedString;
    },
    getCity(filterArr) {
      if (filterArr != undefined) {
        let city_or_country = "Spot";
        if (filterArr.aboutLoc != undefined) {
          if (filterArr.aboutLoc.city != undefined) {
            city_or_country =
              filterArr.aboutLoc.city + ", " + filterArr.aboutLoc.country;
          } else if (filterArr.aboutLoc.state != undefined) {
            city_or_country =
              filterArr.aboutLoc.state + ", " + filterArr.aboutLoc.country;
          } else if (filterArr.aboutLoc.subLocality != undefined) {
            city_or_country =
              filterArr.aboutLoc.subLocality +
              ", " +
              filterArr.aboutLoc.country;
          } else if (filterArr.aboutLoc.region != undefined) {
            city_or_country =
              filterArr.aboutLoc.region + ", " + filterArr.aboutLoc.country;
          } else {
            city_or_country = filterArr.aboutLoc.country;
          }
        }
        return this.getCapitalizedString(city_or_country);
      } else {
        return "";
      }
      return obj;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/colors.scss";
@import "../../assets/scss/mixins.scss";

.padding-right {
  padding-right: 10px;
}

.fullscreen {
  overflow-x: scroll;
  overflow-y: hidden;
}

.no-padding {
  padding: 0;
}

.logo-loader {
  position: absolute;
  top: 50%;
  left: 48%;
}
.video-container {
  height: 100%;
  width: auto;
}
.feedback-speech-bubble {
  margin-left: 10px;
}
.v-lazy-image {
  filter: blur(5px);
  transition: filter 0.7s;
}
.v-lazy-image-loaded {
  filter: blur(0);
}
@mixin blur($value) {
  -webkit-filter: blur($value);
  -moz-filter: blur($value);
  -o-filter: blur($value);
  -ms-filter: blur($value);
  filter: blur($value);
  transform: scale(1.1);
}
pre {
  font-family: MontSerrat-Regular !important;
}

.video-player-youtube {
  position: relative;
  height: 100%;
  width: 100%;
  pointer-events: none !important;
}
.logo-color {
  color: $logo-color;
  font-weight: bolder;
}
.image-details-container {
  position: fixed;
  left: 0;
  right: 0;
  z-index: 100;
  height: 100vh;
  background-color: transparent;

  //
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;

  //padding-top: 1.786em;
  .top-section {
    padding: 0;

    .profile-detail {
      // uploader details
      .uploader-profile {
        display: flex;
        font-size: 0.929em;
        justify-content: flex-end;
        align-items: center;
        .name {
          margin-left: 1em;
          margin-right: 6px;
        }
        .pic {
          height: 1.714em;
          width: 1.714em;
          object-fit: cover;
          border-radius: 100%;
          margin-bottom: 2px;
        }
      }
    }
  }
  .nearby-images {
    position: relative;
    padding-left: 20px;
    padding-bottom: 5em;
    margin-top: 1.2em !important;
    @include fontSize(1.6em);
    color: rgba(255, 255, 255, 0.8);

    .scrollmenu {
      width: 100%;
      white-space: nowrap;
      overflow-x: scroll;
      overflow-y: hidden;
      -webkit-transform: translateZ(0);
    }

    .a-tag {
      padding: 14px 0 14px 0;
      display: inline-block;

      img {
        object-fit: cover;
        border-radius: 15px;
        height: 392px;
        width: 259px;
      }
    }
  }
}
//
.footer {
  background: linear-gradient(
    -180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.61) 62%
  );
  height: 18.740629685157423vh;
  z-index: 200;
  width: 100%;
  position: fixed;
  bottom: 0;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 3.7481259370314843vh;
  i {
    font-size: 30px;
  }
}
.google-maps-open {
  background-color: rgb(80, 227, 194);
  color: $font-color-3;
  cursor: pointer;
  display: flex;
  z-index: 900000000;
  width: 250px;
  height: 43px;
  position: absolute;
  justify-content: center;
  align-items: center;
  text-align: center;
  bottom: 55px;
  border-radius: 100px;
  .text {
    letter-spacing: 1px;
    // font-family: "Avenir", serif;
    font-size: 14px;
    font-weight: 700;
  }
}
.filter-black {
  position: fixed;
  z-index: 2;
  height: 85vh;
  width: 100vw;
  background: linear-gradient(to bottom, #eeeeee, #d8d8d8);
}

.header-det {
  top: 0;
  padding-top: 0.5em;
  left: 0;
  height: 7.429em;
  background: linear-gradient(to top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.61));
  position: fixed;
  width: 100vw;
  display: flex;
  z-index: 101;
  justify-content: flex-end;

  .more-vert {
    display: none;
    margin-right: 0.7em;
    font-size: 1.5em;
    text-align: right;
    color: #9b9b9b;
  }
}

hr {
  border: solid 0.5px #4a4a4a;
}

.audio-button-sound-off {
  align-items: flex-end;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0.5px solid $opacity-color-1;
  background-color: $background-color-1;
  border-radius: 6px;
  cursor: pointer;
  color: white;
  padding: 6px;
  height: 30px;
  i {
    margin-left: 2px;
  }
  label {
    cursor: pointer;
  }
}

.audio-button-sound-on {
  align-items: flex-end;
  margin-top: 10px;
  height: 30px;
  width: 30px;
  padding-right: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0.5px solid $opacity-color-1;
  background-color: $background-color-1;
  border-radius: 50%;
  cursor: pointer;
}

.video-button {
  align-items: flex-end;
  margin-top: 10px;
  height: 30px;
  width: 30px;
  padding-right: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0.5px solid $opacity-color-1;
  background-color: $background-color-1;
  border-radius: 50%;
  cursor: pointer;
  margin: 10px;
}
.video-player-buttons {
  margin-left: 20px;
  @media (max-width: 1024px) {
    display: none;
  }
  top: 0;
  left: 0;
  position: absolute;
  display: inline-flex;
}
.video-player-buttons-small-screen {
  // position: absolute;
  display: flex;
  @media (max-width: 1024px) {
    display: inline-flex;
  }
  display: none;
}
.details-container {
  position: relative;
  //
  .top-section-container {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    z-index: 1500;
    overflow: hidden;
    width: 100%;
    @media (max-width: 768px) {
      height: 37.857em;
    }
    background-color: #000000;
    background-size: auto 85vh;
    background-position: center;
    .view-image {
      height: 100%;
    }
    .view-image-full {
      width: 100%;
      margin-top: -10%;
      @media only screen and (max-width: 768px) {
        margin-top: 50px;
      }
    }

    .top-header-container {
      position: absolute;
      width: 100%;
      height: 7.429em;
      background-image: linear-gradient(
        to top,
        rgba(0, 0, 0, 0),
        rgba(0, 0, 0, 0.06) 13%,
        rgba(0, 0, 0, 0.11) 25%,
        rgba(0, 0, 0, 0.18) 36%,
        rgba(0, 0, 0, 0.26) 45%,
        rgba(0, 0, 0, 0.33) 53%,
        rgba(0, 0, 0, 0.41) 60%,
        rgba(0, 0, 0, 0.48) 66%,
        rgba(0, 0, 0, 0.56) 72%,
        rgba(0, 0, 0, 0.62) 77%,
        rgba(0, 0, 0, 0.68) 81%,
        rgba(0, 0, 0, 0.73) 86%,
        rgba(0, 0, 0, 0.77) 90%,
        rgba(0, 0, 0, 0.79) 95%,
        rgba(0, 0, 0, 0.8)
      );
      top: 0;
      left: 0;
      display: flex;
      align-items: flex-start;
      justify-content: flex-end;

      padding: 10px;

      .header-content {
        width: 100vw;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        position: relative;
        //
        .month-duration {
          display: flex;
          font-family: MontSerrat;
          font-size: 0.6875em;
          text-align: right;
          color: $font-color-3;
          margin-bottom: 0.625em;
          .month-name {
            margin-right: 0.3125em;
          }
          .dur-time {
            margin-left: 0.3125em;
          }
        }
        //
        //
        .top-menu-icons {
          @media only screen and (min-width: 768px) {
            flex-grow: 1;
          }
          display: flex;
          justify-content: center;
        }
        //
        .image-time-place-details {
          flex-grow: 1;
          display: flex;
          align-items: center;
          flex-direction: column;
          .city-viewtype {
            padding: 0.3125em 0.9375em;
            background-color: rgba(0, 0, 0, 0.8);
            color: $font-color-3;
            border-radius: 4px;
            display: flex;
            align-items: baseline;
            cursor: pointer;
            @media only screen and (min-width: 768px) {
              @include fontSize(1em);
            }
            font-size: 0.75em;
            font-family: "Montserrat-Regular", -apple-system, BlinkMacSystemFont,
              "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans",
              "Helvetica Neue", sans-serif !important;
            .spotTypeOthers {
              font-weight: bold;
            }
          }
        }
        //
        .white-line {
          height: 1px;
          border-radius: 2px;
          @media only screen and (max-width: 768px) {
            width: 100%;
          }
          width: 60%;
          background-color: $background-color-2;
          margin-bottom: 5px;
        }
        .image-carousal {
          position: relative;
          margin-bottom: 0.625em;
          width: 50%;
          display: flex;
          .img-progress-bar {
            margin-left: 1px;
            margin-right: 1px;
            height: 2px;
            border-radius: 3px;
            background-color: $background-color-2;
            animation: fill-length 3s linear;
          }
          .img-progress-bar .passed {
            width: 100%;
            background-color: $background-color-2;
          }
          .img-progress-bar .active {
            animation: fill-length 3s linear;
          }
          .img-progress-bar-container {
            flex-grow: 1;
            margin-left: 1px;
            margin-right: 1px;
            height: 2px;
            border-radius: 3px;
            background-color: rgba(0, 0, 0, 0.8);
          }

          @keyframes fill-length {
            0% {
              width: 0%;
            }
            100% {
              width: 100%;
            }
          }
        }
        //
        .go-back-container {
          @media only screen and (min-width: 768px) {
            flex-grow: 1;
          }
          .go-back-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 100px;
            padding: 0.5em;
            z-index: 10000000;
            @media only screen and (max-width: 768px) {
              display: block;
            }
            i {
              transform: translate(21%, 0);
              font-size: 1em;
            }
            justify-content: flex-start;
            width: fit-content;
            cursor: pointer;
          }
        }
        //
      }
    }
    .fullscreen-footer {
      position: absolute;
      width: 100%;
      height: 4.714em;
      background-image: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0),
        rgba(0, 0, 0, 0.01) 7%,
        rgba(0, 0, 0, 0.03) 13%,
        rgba(0, 0, 0, 0.07) 18%,
        rgba(0, 0, 0, 0.11) 24%,
        rgba(0, 0, 0, 0.17) 29%,
        rgba(0, 0, 0, 0.23) 34%,
        rgba(0, 0, 0, 0.3) 39%,
        rgba(0, 0, 0, 0.38) 45%,
        rgba(0, 0, 0, 0.45) 51%,
        rgba(0, 0, 0, 0.53) 59%,
        rgba(0, 0, 0, 0.6) 67%,
        rgba(0, 0, 0, 0.68) 76%,
        rgba(0, 0, 0, 0.74) 87%,
        rgba(0, 0, 0, 0.8)
      );
      bottom: 0;
      left: 0;
      padding: 0.5em 1em;
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
      //
      .footer-content {
        width: 100%;
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        .like-share-fullscreen-container {
          display: flex;
          width: calc(100vw / 3);
          align-items: center;
          color: $font-color-3;
          i {
            color: $font-color-3;
          }
        }
        .street-view-link {
          width: calc(100vw / 3);
          display: flex;
          @media only screen and (max-width: 768px) {
            display: none;
          }
          justify-content: center;
          a:first-child {
            border-top-left-radius: 6px;
            border-bottom-left-radius: 6px;
          }
          a:last-child {
            border-top-right-radius: 6px;
            border-bottom-right-radius: 6px;
          }

          .street-view-link-button {
            flex-grow: 1;
            text-align: center;
            font-family: "Montserrat-Regular", -apple-system, BlinkMacSystemFont,
              "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans",
              "Helvetica Neue", sans-serif;
            font-size: 12px;
            font-weight: bold;
            color: $font-color-3;
            border: solid 0.5px $primary-color-2;
            align-items: center;
            @media only screen and (max-width: 768px) {
              display: inline-flex !important;
              justify-content: center;
              margin-left: auto;
              margin-right: auto;
              width: 100%;
              margin-top: 10px;
            }
            flex-direction: column;
            background-color: $background-transparent-1;
            padding: 0.625em 0.9375em;
            text-decoration: none;
            display: flex;
            width: max-content;
            .virtual-doll {
              width: 17px;
              height: 20px;
            }
            img,
            i {
              margin-right: 7px;
            }
          }
          .get-directions-link-button {
            flex-grow: 1;
            font-family: "Montserrat-Regular", -apple-system, BlinkMacSystemFont,
              "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans",
              "Helvetica Neue", sans-serif;
            font-size: 12px;
            font-weight: bold;
            justify-content: flex-end;
            color: $font-color-3;
            border: solid 0.5px $primary-color-2;
            @media only screen and (max-width: 768px) {
              display: inline-flex !important;
              justify-content: center;
              margin-left: auto;
              margin-right: auto;
              width: 100%;
              margin-top: 10px;
            }
            border: 0.5px solid $primary-color-2;
            background-color: $background-transparent-1;
            padding: 0.625em 0.9375em;
            text-decoration: none;
            width: max-content;
            display: flex;
            flex-direction: column;
            align-items: center;
            .heli-view-image {
              width: 33px;
              height: 17px;
            }
            img {
              height: 17px;
            }
          }
          .get-directions-botton-flex {
            flex-grow: 1;
            font-family: "Montserrat-Regular", -apple-system, BlinkMacSystemFont,
              "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans",
              "Helvetica Neue", sans-serif;
            font-size: 12px;
            font-weight: bold;
            justify-content: center;
            color: $font-color-3;
            border: solid 0.5px $primary-color-2;
            @media only screen and (max-width: 768px) {
              display: inline-flex !important;
              justify-content: center;
              margin-left: auto;
              margin-right: auto;
              width: 100%;
              margin-top: 10px;
            }
            border: 0.5px solid $primary-color-2;
            background-color: $background-transparent-1;
            padding: 0.625em 0.9375em;
            text-decoration: none;
            width: max-content;
            display: flex;
            align-items: center;
            .heli-view-image {
              width: 33px;
              height: 17px;
              margin-right: 12px;
            }
            img {
              height: 17px;
            }
            i {
              margin-right: 12px;
            }
          }
          i {
            font-size: 18px;
          }
        }
        .want-to-go-like {
          display: flex;
          justify-content: flex-end;
          color: $font-color-3;
          i {
            color: $font-color-3;
            font-size: 1.7em;
            @media only screen and (max-width: 768px) {
              font-size: 1.3em;
            }
          }
          .likes-container {
            display: flex;
            align-items: center;
            margin-right: 0.6em;
          }
          .likes-count {
            margin-right: 0.6em;
          }
        }
        .want-to-go-button-scroll {
          @include fontSize(1em);
          position: relative;
          z-index: 8;
          border-radius: 0.375em;
          padding: 0.3em 0.9375em;
          outline: none;
          display: flex;
          align-items: center;
          font-family: "Montserrat-Regular", -apple-system, BlinkMacSystemFont,
            "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans",
            "Helvetica Neue", sans-serif;
          font-size: 0.6875em;
          font-weight: bold;
          i {
            z-index: 10 !important;
            color: $font-color-4;
            padding-left: 0.7em;
            font-size: 1.3em;
          }
        }
        .want-to-go {
          background-color: $logo-color;
          color: $font-color-3;
        }
        .on-travel-list {
          background-color: $background-color-1;
          color: $font-color-4;
          border: 0.5px solid $opacity-color-1;
        }
        .share-like {
          position: relative;
          width: calc(100vw / 3);
          @media only screen and (max-width: 768px) {
            width: auto;
          }
        }
        .share-btn {
          display: flex;
          margin-bottom: 0.9375em;
          justify-content: flex-end;
          color: $font-color-3;
          i {
            font-size: 1.7em;
            color: $font-color-3;
            transform: scaleX(-1);
            @media only screen and (max-width: 768px) {
              font-size: 1.3em;
            }
          }
        }
      }
    }
  }
}
//
.inner {
  overflow-x: hidden;
  padding: 0.5em 1em;
  position: absolute;
  top: 42%;
  width: 100%;
  right: 0px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: end;
  -ms-flex-align: end;
  align-items: flex-end;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: space-between;
  //
  @media (max-width: 1024px) {
    top: 45%;
  }

  .arrow-container {
    height: 50px;
    width: 50px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.3);
    @media (max-width: 1024px) {
      height: auto;
      width: auto;
    }
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  //
  .arrow-buttons {
    cursor: pointer;
    color: $primary-color-1;
    transform: scale(1.7);
    @media (max-width: 1024px) {
      transform: scale(1.3);
    }
  }

  //
  //
  .loading-container {
    margin-right: -22px;
    @media (max-width: 1024px) {
      margin-right: -40px;
    }
    height: 100px;
    width: 100px;
    .loading {
      transform: scale(0.3);
      width: 100px;
      height: 100px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;

      -webkit-transform: scale(0.3);
      -webkit-width: 100px;
      -webkit-height: 100px;
      -webkit-position: relative;
      -webkit-display: flex;
      -webkit-align-items: center;
      -webkit-width: 100px;
      -webkit-height: 100px;
      -webkit-position: relative;
      -webkit-display: flex;
      -webkit-align-items: center;
      -webkit-justify-content: center;

      .text {
        position: absolute;
        z-index: 20;
        font-size: 2.5em;
        color: #999999;
        font-weight: 600;
      }
    }

    .outer-shadow {
      z-index: 2;
      background: transparent;

      -webkit-z-index: 2;
      -webkit-background: transparent;
    }
    .outer-shadow,
    .inner-shadow {
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 100%;
      -webkit-position: absolute;
      -webkit-width: 100%;
      -webkit-height: 100%;
      -webkit-border-radius: 100%;
    }

    .inner-shadow {
      z-index: 6;
      transform: scale(1.1);
      top: 50%;
      left: 50%;
      width: 80px;
      height: 80px;
      margin-left: -40px;
      margin-top: -40px;
      border-radius: 100%;
      background-color: black;

      -webkit-z-index: 6;
      -webkit-transform: scale(1.1);
      -webkit-top: 50%;
      -webkit-left: 50%;
      -webkit-width: 80px;
      -webkit-height: 80px;
      -webkit-margin-left: -40px;
      -webkit-margin-top: -40px;
      -webkit-border-radius: 100%;
      -webkit-background-color: black;
      // box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.5);
    }
    .hold {
      z-index: 0 !important;
      position: absolute;
      width: 100%;
      height: 100%;
      clip: rect(0px, 100px, 100px, 50px);
      border-radius: 100%;
      background-color: transparent;
      -webkit-z-index: 0 !important;
      -webkit-position: absolute;
      -webkit-width: 100%;
      -webkit-height: 100%;
      -webkit-clip: rect(0px, 100px, 100px, 50px);
      -webkit-border-radius: 100%;
      -webkit-background-color: transparent;
    }

    .fill,
    .dot span {
      background-color: #9b9b9b;
      -webkit-background-color: #9b9b9b;
    }

    .fill {
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 100%;
      clip: rect(0px, 50px, 100px, 0px);

      -webkit-position: absolute;
      -webkit-width: 100%;
      -webkit-height: 100%;
      -webkit-border-radius: 100%;
      -webkit-clip: rect(0px, 50px, 100px, 0px);
    }

    @keyframes left {
      0% {
        -webkit-transform: rotate(0deg);
      }
      100% {
        -webkit-transform: rotate(180deg);
      }
    }

    @-webkit-keyframes left {
      0% {
        -webkit-transform: rotate(0deg);
      }
      100% {
        -webkit-transform: rotate(180deg);
      }
    }
    .left .fill {
      -webkit-animation-play-state: running;
      -webkit-animation: left 3s linear;
      -moz-animation: left 3s linear;
      animation: left 3s linear both;
    }

    .right {
      -webkit-transform: rotate(180deg);
      -moz-transform: rotate(180deg);
      transform: rotate(180deg);
    }

    @keyframes right {
      0% {
        -webkit-transform: rotate(0deg);
      }
      100% {
        -webkit-transform: rotate(180deg);
      }
    }

    @-webkit-keyframes right {
      0% {
        -webkit-transform: rotate(0deg);
      }
      100% {
        -webkit-transform: rotate(180deg);
      }
    }
    .right .fill {
      -webkit-animation-play-state: running;
      -webkit-animation: left 3s linear;
      -moz-animation: left 3s linear;
      animation: left 3s linear both;
      -webkit-animation-delay: 3s;
      -moz-animation-delay: 3s;
      animation-delay: 3s;
    }
  }
  //
}
//
.bottom-container {
  top: 85vh;
  @media (max-width: 768px) {
    top: 37.857em;
  }
  position: relative;
  //
  .photographer-profile-det {
    padding-bottom: 8em;
    position: absolute;
    top: 0;
    width: 100%;
    .mobile-street-links-nearby {
      display: none;
      @media only screen and (max-width: 768px) {
        display: block;
      }
      .street-view-link {
        margin-bottom: 10px;
        width: 100%;
        display: flex;
        justify-content: center;
        a:first-child {
          border-top-left-radius: 6px;
          border-bottom-left-radius: 6px;
        }
        a:last-child {
          border-top-right-radius: 6px;
          border-bottom-right-radius: 6px;
        }

        .street-view-link-button {
          flex-wrap: wrap;
          flex-grow: 1;
          text-align: center;
          font-family: "Montserrat-Regular", -apple-system, BlinkMacSystemFont,
            "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans",
            "Helvetica Neue", sans-serif;
          font-size: 12px;
          font-weight: bold;
          color: $font-color-3;
          border: solid 0.5px $primary-color-2;
          align-items: center;
          @media only screen and (max-width: 768px) {
            display: inline-flex !important;
            justify-content: center;
            margin-left: auto;
            margin-right: auto;
            width: 100%;
            margin-top: 10px;
          }
          flex-direction: column;
          background-color: $background-transparent-1;
          padding: 0.625em 0.9375em;
          text-decoration: none;
          display: flex;
          width: max-content;
          .virtual-doll {
            width: 17px;
            height: 20px;
          }
          img,
          i {
            margin-right: 7px;
          }
        }
        .get-directions-link-button {
          flex-grow: 1;
          font-family: "Montserrat-Regular", -apple-system, BlinkMacSystemFont,
            "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans",
            "Helvetica Neue", sans-serif;
          font-size: 12px;
          font-weight: bold;
          justify-content: flex-end;
          color: $font-color-3;
          border: solid 0.5px $primary-color-2;
          @media only screen and (max-width: 768px) {
            display: inline-flex !important;
            justify-content: center;
            margin-left: auto;
            margin-right: auto;
            width: 100%;
            margin-top: 10px;
          }
          border: 0.5px solid $primary-color-2;
          background-color: $background-transparent-1;
          padding: 0.625em 0.9375em;
          text-decoration: none;
          width: max-content;
          display: flex;
          flex-direction: column;
          align-items: center;
          .heli-view-image {
            width: 33px;
            height: 17px;
          }
          img {
            height: 17px;
          }
        }
        .get-directions-botton-flex {
          flex-grow: 1;
          font-family: "Montserrat-Regular", -apple-system, BlinkMacSystemFont,
            "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans",
            "Helvetica Neue", sans-serif;
          font-size: 12px;
          font-weight: bold;
          justify-content: center;
          color: $font-color-3;
          border: solid 0.5px $primary-color-2;
          @media only screen and (max-width: 768px) {
            display: inline-flex !important;
            justify-content: center;
            margin-left: auto;
            margin-right: auto;
            width: 100%;
            margin-top: 10px;
          }
          border: 0.5px solid $primary-color-2;
          background-color: $background-transparent-1;
          padding: 0.625em 0.9375em;
          text-decoration: none;
          width: max-content;
          display: flex;
          align-items: center;
          .heli-view-image {
            width: 33px;
            height: 17px;
            margin-right: 12px;
          }
          img {
            height: 17px;
          }
          i {
            margin-right: 12px;
          }
        }
        i {
          font-size: 18px;
        }
      }
      .nearby-and-maps-links {
        display: flex;
        .nearby-button {
          width: 100%;
          font-family: "Montserrat-Regular", -apple-system, BlinkMacSystemFont,
            "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans",
            "Helvetica Neue", sans-serif;
          font-size: 12px;
          font-weight: 800;
          border: solid 0.5px $font-color-2;
          background-image: -webkit-gradient(
            linear,
            left top,
            right top,
            color-stop(75%, #000000),
            color-stop(25%, #bd10e0)
          );
          color: $font-color-2;
          text-decoration: none;
          padding: 8px;
          border-radius: 6px;
        }
      }
    }
    .photographer-profile-det-container {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 2.5em;
      margin-bottom: 0.6875em;
      flex-wrap: nowrap;
      @media only screen and (max-width: 768px) {
        height: auto;
        flex-wrap: wrap;
      }
      img {
        height: 1.5em;
        width: 1.5em;
        object-fit: cover;
        border-radius: 100%;
      }
      .no-profile-image {
        width: 1.5em;
        height: 1.5em;
        border-radius: 100%;
        background: $font-color-3;
        font-size: 20px;
        color: black;
        text-align: center;
        line-height: 1.5em;
        font-weight: bold;
      }
      //
      .nearby-and-maps-links {
        width: calc(100vw / 3);
        display: flex;
        @media only screen and (max-width: 768px) {
          display: none;
        }
        .nearby-button {
          width: 100%;
          font-family: "Montserrat-Regular", -apple-system, BlinkMacSystemFont,
            "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans",
            "Helvetica Neue", sans-serif;
          font-size: 12px;
          font-weight: 800;
          border: solid 0.5px $font-color-2;
          background-image: -webkit-gradient(
            linear,
            left top,
            right top,
            color-stop(75%, #000000),
            color-stop(25%, #bd10e0)
          );
          color: $font-color-2;
          text-decoration: none;
          padding: 8px;
          border-radius: 6px;
        }
      }
      //
      .name-container {
        margin: auto 0.8em auto 0px;
        font-size: 0.9em;
        text-transform: capitalize;
        font-family: "Montserrat-Regular", -apple-system, BlinkMacSystemFont,
          "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans",
          "Helvetica Neue", sans-serif;
        @media only screen and (max-width: 768px) {
          font-size: 0.6875em;
        }
        font-weight: 500;
      }

      //
      .distance {
        color: $font-color-3;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: calc(100vw / 3);
        font-family: "Montserrat-Regular", -apple-system, BlinkMacSystemFont,
          "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans",
          "Helvetica Neue", sans-serif;
        font-size: 0.8125em;
        .loc-detail {
          display: flex;
          align-items: center;
          pre b {
            font-weight: bold;
          }
        }
        @media only screen and (max-width: 768px) {
          flex-grow: 1;
        }
        i {
          font-size: 1em;
          margin-right: 5px;
        }
      }
      //
      .photographer-profile-user {
        width: calc(100vw / 3);
        color: $font-color-3;
        img {
          margin-right: 0.8em;
        }
        @media only screen and (max-width: 768px) {
          flex-grow: 1;
        }
      }
      //
      .photographer-profile {
        color: $font-color-5;
        width: calc(100vw / 3);
        @media only screen and (max-width: 768px) {
          flex-grow: 1;
        }
      }
      //
    }
    //
    .caption {
      text-align: left;
      margin-top: 1.25em;
      margin-bottom: 1.25em;
      // @include fontSize(1.1875em)
      font-size: 1.1875em !important;
      font-weight: bold;
      color: $font-color-3;
      font-family: "Montserrat-Regular", -apple-system, BlinkMacSystemFont,
        "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans",
        "Helvetica Neue", sans-serif;
    }
    //
    .enable-loc {
      margin: 1.2em 0 0 0;
      padding-left: 0.5em;
      text-align: left;
      font-size: 1em;
      color: $font-color-3;
      font-family: MontSerrat-Regular;

      i {
        font-size: 1em;
      }
    }
    hr {
      margin-top: 1.2em;
    }
  }
}

//page footer
.user-footer-bottom {
  position: fixed;
  bottom: 0;
  bottom: -50px;
  width: 100vw;
  z-index: 200;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  color: $font-color-3;
  background-color: rgb(21, 21, 21);
  @media only screen and (min-width: 768px) {
    background-color: transparent;
    bottom: -50px;
  }
  opacity: 0.8;
  height: 50px;
  padding: 5px;
  .wav-icon-footer {
    height: 14px;
    @media only screen and (min-width: 768px) {
      height: 10px;
    }
  }
  .user_account {
    width: 1.75em;
  }

  i {
    font-size: 18px;
  }
  button {
    outline: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .footer-icons {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    font-family: "Montserrat-Regular", -apple-system, BlinkMacSystemFont,
      "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans",
      "Helvetica Neue", sans-serif;
    span {
      // display: block;
      font-size: 10px;
      cursor: pointer;
    }
  }
  .option-container {
    cursor: pointer;
    width: 56px;
    display: flex;
  }
  .search-icon-text {
    justify-content: flex-end;
  }
}

//Nearby photos section styles
.near-height {
  margin-bottom: 2em;
  padding-top: 1.0625em;
  font-size: 0.875em;
  background-color: $background-color-3;
  font-family: "Montserrat-Regular", -apple-system, BlinkMacSystemFont,
    "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue",
    sans-serif;
}

//disabled selects for month and duration currently commented
.disable-select {
  scroll-behavior: smooth;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */
  -khtml-user-select: none; /* Konqueror */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently supported by any browser but < IE9 */
}

.custom-select {
  position: relative;
  outline: none;
  margin-right: 1em;
}
//custom select labels for month and duration currently commented
.custom-select__label {
  outline: none;
  font-size: 0.919em;
  display: flex;
  align-items: center;
  cursor: pointer;
  @media screen and (max-width: 600px) {
    color: #9b9b9b;
  }
  @media screen and (min-width: 601px) {
    color: $font-color-3;
    font-weight: bold;
  }
}
// custom selects for month and duration currently commented
.custom-select__label-down-arrow {
  padding-left: 0.313em;
  @media screen and (max-width: 600px) {
    height: 1.5em;
  }
  @media screen and (min-width: 601px) {
    height: 1.1em;
  }
}
.custom-select__label-down-arrow_mobile {
  @media screen and (min-width: 601px) {
    display: none;
  }
}
.custom-select__label-down-arrow_desktop {
  @media screen and (max-width: 600px) {
    display: none;
  }
}
//
.custom-select__options {
  position: absolute;
  top: 1.5em;
  right: 0;
  background: $background-color-2;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  padding: 0.7em 1em;
  border-radius: 8px;
}
.custom-select__option {
  cursor: pointer;
  font-size: 0.818em;
  padding-top: 0.05em;
  padding-bottom: 0.05em;
}
.custom-select__option_selected {
  font-weight: 500;
  color: #333333;
}
.custom-select__option_disabled {
  color: #999999;
}

// new styles
.media-top-section {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 90px;
  padding-bottom: 90px;
  background-color: #151515;
  @media screen and (max-width: 768px) {
    padding-top: 60px;
  }
  .top-section {
    position: relative;
    overflow: hidden;
    padding: 10px;
    .photo-details {
      display: none;
      @media screen and (max-width: 768px) {
        display: flex;
        flex-direction: column;
        color: white;
        flex-grow: 1;
        text-align: left;
        align-items: center;
        padding-bottom: 20px;
        .caption {
          font-size: 14px !important ;
          font-weight: 600;
          margin-bottom: 10px;
          line-height: 1.2;
          text-align: center;
        }
        .location {
          font-size: 11px !important;
          line-height: 1.03;
          display: flex;
        }
        .nearby-button-mobile {
          width: 100%;
          font-family: "MontSerrat";
          font-weight: 700;
          padding: 8px;
          background-color: #5b5b5b;
          border-radius: 6px;
          text-align: center;
          color: white;
          text-decoration: none;
          margin-top:10px;
        }
        .photographer-details {
          display: flex;
          justify-content: space-between;
          width: 100%;
          font-size: 10px !important ;
          padding: 16px;
        }
      }
    }
    .photo-details-description {
      background-color: black;
      border-radius: 10px;
      padding-top: 10px;
      padding-bottom: 20px;
      margin-bottom: -10px;
    }
    .video-card {
      width: 100vw;
      height: 65vh;
    }
    .image-card {
      border-radius: 12px;
      position: relative;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 1130px;
      height: 65vh;
      .image-card-image {
        width: 100%;
        height: auto;
        @media screen and (max-width: 768px) {
          width: auto;
          height: 100%;
        }
      }
      @media screen and (max-width: 1130px) {
        width: 100%;
        height: 47vh;
      }
    }
  }

  .like-share-container {
    position: absolute;
    top: 0;
    right: 0;
    padding: 20px 10px;
    display: flex;
    .icon-container {
      height: 45px;
      width: 45px;
      background-color: rgba(0, 0, 0, 0.5);
      border-radius: 50%;
      color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      i {
        font-size: 30px;
      }
      .share-icon {
        height: 30px;
        width: 30px;
      }
      @media screen and (max-width: 768px) {
        height: 30px;
        width: 30px;
        i {
          font-size: 18px;
        }
        .share-icon {
          height: 18px;
          width: 18px;
        }
      }
    }
  }

  .control-section {
    width: 100%;
    background-color: transparent;
    padding: 22px 0px;
    display: flex;
    max-width: 1130px;
    justify-content: space-between;
    @media screen and (max-width: 768px) {
      margin-top: -10px;
      padding: 20px 0 10px 0;
      background-color: black;
      border-radius: 0 0 10px 10px;
      margin-bottom: 5px;
    }
    .location-details {
      display: flex;
      flex-grow: 1;
      @media screen and (max-width: 768px) {
        justify-content: center;
      }
    }
    .control-item {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      margin-right: 20px;
      color: white;
      @media screen and (max-width: 768px) {
        font-size: 11px;
      }
      label {
        cursor: pointer;
      }
      img {
        height: 36px;
        width: auto;
        @media screen and (max-width: 768px) {
          height: 20px;
        }
      }

      i {
        font-size: 36px;
        @media screen and (max-width: 768px) {
          font-size: 20px;
        }
      }
    }

    a {
      text-decoration: none;
      color: white;
    }
    .nearby-places {
      display: flex;
      @media screen and (max-width: 768px) {
        display: none;
      }
      .nearby-button {
        font-family: "MontSerrat";
        font-weight: 700;
        padding: 1.25rem 4.5rem;
        background-color: #5b5b5b;
        border-radius: 6px;
      }
      .feedback {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-right: 20px;
        color: white;
        img {
          height: 25px;
          width: auto;
        }

        i {
          font-size: 36px;
        }
      }
    }
  }
}
//TOOLBAR STYLES
.search-top-city-container {
  z-index: 999;
  top: 0;
  width: 100%;
  position: fixed;
  color: white;
  background-color: $background-color-6;
  transition: top 1s;

  .toolbar-content-container {
    position: relative;
    width: 100%;
    padding: 0.625rem;
    background-color: $background-color-1;
    color: white;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;

    .cursor {
      cursor: pointer;
    }

    .fullscreen-mode-text {
      font-size: 11px;
      display: none;
      cursor: pointer;

      @media only screen and (max-width: 768px) {
        font-size: 11px;
        display: block;
      }
    }

    .list-view-text {
      display: flex;
      flex-direction: column;
      font-size: 16px;
      font-weight: bold;
      justify-content: center;
      font-family: MontSerrat;
      align-items: center;
      flex-grow: 1;
      .search-component {
        display: block;
        @media screen and (max-width: 1024px) {
          display: none;
        }
      }
      .logo-color {
        font-family: MontSerrat;
        color: $logo-color;
      }
    }
    .heading-text {
      display: flex;
      align-items: baseline;
      @media only screen and (min-width: 1024px) {
        display: none;
      }
    }
  }

  .header-section-3 {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    .pill-container {
      display: none;
      border-radius: 2rem;
      border: 0.5px solid $primary-color-2;
      @media only screen and (min-width: 768px) {
        display: flex;
      }
    }
    .pill {
      padding: 1rem 2rem 0.4rem 2rem;
      * {
        cursor: pointer;
        padding: 0;
        margin: 0;
      }
    }
  }
  .pills-description {
    margin-top: 5px;
    display: none;
    @media only screen and (min-width: 768px) {
      display: flex;
    }
    .description-item {
      flex-grow: 1;
      font-size: 12px;
    }
  }

  .search-city-relative {
    position: relative;
    width: 100%;

    //
    display: flex;
    align-items: center;
    justify-content: space-between;

    i {
      opacity: 0.6;
      color: white;
      font-size: 1.286em;
    }

    .i-1 {
      left: 20px;
    }

    .i-2 {
      left: 65px;
    }

    .i-3 {
      right: 3em;
    }

    .i-4 {
      right: 22px;
    }
  }
}

.search-top-city-container-hide {
  display: none;
  transition: top 2s ease 0s;
}
.go-back-icon-and-fullscreen-mobile {
  display: none;
  font-family: Montserrat;
  padding: 3px;
  text-decoration: none;
  color: $primary-color-1;

  i {
    font-size: 12px;
    margin-right: 5px;
  }
  @media only screen and (min-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-weight: bold;
    flex-grow: 1;
    .logo {
      display: flex;
      align-items: baseline;
      color: $logo-color;
    }
  }
}

// sticky footer styles
.sticky-footer {
  position: fixed;
  bottom: 0;
  padding: 15px 0px;
  background-color: #d9d9d9;
  display: flex;
  align-items: center;
  font-family: "MontSerrat-Regular";
  z-index: 999;
  width: 100%;
  @media screen and (max-width: 786px) {
    padding: 10px 0px;
  }
  .logo {
    text-decoration: none;
    color: black;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0px 10px 0 0;

    img {
      height: 18px;
    }
    @media screen and (max-width: 786px) {
      font-size: 11px;
      img {
        height: 14px;
      }
    }
  }

  .list-view-btn {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #000;
    @media screen and (max-width: 768px) {
      font-size: 11px;

      i {
        font-size: 18px;
      }
    }
  }
  .navigations {
    display: flex;
    padding: 0px 20px;
    border-right: 1px solid #979797;
    margin-right: 10px;
  }
  .photo-description {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0px 20px;
    color: black;
    flex-grow: 1;
    text-align: left;
    justify-content: space-around;
    .caption {
      font-size: 24px !important ;
      font-weight: 600;
      line-height: 1.2;
      max-width: 600px;
    }
    .location {
      font-size: 18px !important;
      font-weight: 600;
      line-height: 1.03;
      display: flex;
    }
    @media screen and (max-width: 786px) {
      display: none;
    }
  }
  .check-price-btn {
    padding: 12px 30px;
    border-radius: 4px;
    background-color: #655fff;
    font-family: "Montserrat";
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 2;
    letter-spacing: normal;
    text-align: center;
    color: #fff;
    text-decoration: none;
    height: fit-content;

    @media screen and (max-width: 768px) {
      font-size: 12px;
      padding: 4px 16px;
      margin-left: auto;
    }
    @media screen and (max-width: 360px) {
      font-size: 10px;
      margin-left: auto;
    }
  }

  .read-review-btn {
    padding: 12px 30px;
    border-radius: 4px;
    background-color: black;
    font-family: "Montserrat";
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 2;
    letter-spacing: normal;
    text-align: center;
    color: #fff;
    text-decoration: none;
    height: fit-content;
    @media screen and (max-width: 768px) {
      font-size: 12px;
      padding: 4px 16px;
    }
    @media screen and (max-width: 360px) {
      font-size: 10px;
      margin-left: auto;
    }
  }

  .travel-list-btn {
    font-family: "Montserrat";
    font-size: 14px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 14px 30px;
    border-radius: 4px;
    margin-left: 10px;
    margin-right: 20px;
    height: fit-content;

    @media screen and (max-width: 768px) {
      font-size: 12px;
      line-height: 2;
      padding: 4px 16px;
      margin-right: 15px;
      i {
        display: none;
      }
    }
    @media screen and (max-width: 360px) {
      font-size: 10px;
      margin-left: auto;
    }
  }
  .checked {
    background-color: black;
    border: 1px solid $font-color-4;
    color: $font-color-4;
    i {
      color: $font-color-4;
      font-size: 12px;
    }
  }
  .add {
    background-color: #bd10e0;
    color: white;
  }
}
</style>



// WEBPACK FOOTER //
// imageDetails.vue?032df4d1